'use strict';

class SubscriptionsPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    let initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getSubscriptions(startDate, endDate)
        .then((reportInfo) => {
          if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
            return [];
          }

          if (initial) {
            getLastMeasurement(reportInfo.executions[reportInfo.executions.length - 1]);
            initial = false;
          }

          return reportInfo.dictionary
            .sort((a, b) => a.id - b.id)
            .map(dictValue => ({
              label: dictValue.name,
              data: reportInfo.executions
                .map(e => ({
                  x: e.executionDateMs,
                  y: e.data?.find(datum => JSON.stringify(datum.id) === JSON.stringify(dictValue.id))?.value
                }))
                .filter(e => e.y != null)
            }))
            .filter(d => d.data.length > 0);
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(executions) {
      if (!executions) {
        return;
      }

      let info = [];
      info.push({
        icon: 'clock',
        name: $t('dash.panel.reports.lastMeasured'),
        value: $filter('date')(executions.executionDateMs, currentDateFormat)
      });

      // Get total except "no subscriptions"
      let total = 0;
      for (let [key, value] of Object.entries(executions.data || {})) {
        total += value.id !== 0 ? value.value : 0;
      }
      info.push({
        icon: 'scroll',
        name: $t('dash.panel.reports.subscriptions.totalSubscriptions'),
        value: total
      });

      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.subscriptionsPage.controller', [])
  .controller('SubscriptionsPageController', SubscriptionsPageController)
  .name;
